import { render, staticRenderFns } from "./FixedHeader.vue?vue&type=template&id=fc680c42"
import script from "./FixedHeader.vue?vue&type=script&lang=js"
export * from "./FixedHeader.vue?vue&type=script&lang=js"
import style0 from "./FixedHeader.vue?vue&type=style&index=0&id=fc680c42&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports